module.exports = __webpack_public_path__ + "static/home-fd780545711da1bdee622df335827cdd.svg";